import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DashboardComponent } from './dashboard/dashboard.component';
import { NoRoleRoutingModule } from './no-role-routing.module';

@NgModule({
  declarations: [DashboardComponent],
  imports: [CommonModule, NoRoleRoutingModule],
})
export class NoRoleModule {}
